import React, { useState, useCallback } from "react";

export const useSelectedList = () => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const onSelect = useCallback(
    (id: string) => {
      setSelectedIds((selected) => {
        if (selected.includes(id)) {
          return [...selected.filter((o) => o !== id)];
        }
        return [...selected, id];
      });
    },
    [setSelectedIds]
  );

  const clearSelected = useCallback(() => setSelectedIds([]), [setSelectedIds]);

  const isSelected = useCallback(
    (id: string) => selectedIds.includes(id),
    [selectedIds]
  );
  return { onSelect, selectedIds, isSelected, clearSelected, setSelectedIds };
};
